// souscription.stats.dto.ts
import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const souscriptionStatsSchema = z.object({
  active: z.number(),
  expired: z.number(),
  total: z.number(),
});

export class SouscriptionStatsDto extends createZodDto(souscriptionStatsSchema) {}

export const souscriptionByRateSchema = z.array(
  z.object({
    rateId: z.string(),
    rateName: z.string(),
    count: z.number(),
  }),
);

export class SouscriptionByRateDto extends createZodDto(souscriptionByRateSchema) {}
